import { BaseDataService } from './BaseDataService';
import { Organization, Report9BoxSettings } from '../../models';
import { NotificationService } from '..';

export class TeamologyDataService extends BaseDataService<Report9BoxSettings> {
    constructor(notificationService: NotificationService) {
        super('Teamology', 'Teamology', notificationService);
    }

    public getConfig(organization: Organization): Promise<any> {
        const endpoint = `${this.endpointRoot}/config/${organization.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public updateConfig(organization: Organization, data: any): Promise<any> {
        const endpoint = `${this.endpointRoot}/config/${organization.id}`;
        const init = this.buildRequestInit('PUT', data);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/TeamologyDataService.tsx